import type { OAuthStore } from './interfaces'

export const getters = {
  isLoading: (state: OAuthStore): OAuthStore['loading'] => state.loading,
  getGoogle: (state: OAuthStore): OAuthStore['google'] => state.google,
  getZoho: (state: OAuthStore): OAuthStore['zoho'] => state.zoho,
}
